<href class="height-100"
     [link]="model?.data?.url">
    <div class="w-12 ratio-3-2">
        <img class="rf"
             [image]="model?.data?.image"
             [attr.alt]="model?.data?.name">
    </div>
    <div class="center">
        <!-- tags -->
        <div class="m-t-2">
            @for (tag of tagCategories; track tag; let first = $first) {
            <div class="bg-col-5 p-r-1 p-l-1 m-t-2 m-l-1 inline-block"
                 [style.padding-top.px]="1"
                 [style.padding-bottom.px]="1">
                <span class="o1">{{tag.name}}</span>
            </div>
            }
        </div>
        <!-- title -->
        <p class="h3 m-t m-t-2-s p-l p-r">
            {{model?.name}}
        </p>
        <!-- Date -->
        <div class="va-m p2 col-11 m-t-1 m-t-2-s">
            <p class="inline-block">{{typeData?.date | date: 'MMMM dd, yyyy'}}</p>
            @if (typeData?.date && typeData?.readingTime) {
            <span class="inline-block p-l-1 p-r-1">|</span>
            <p class="inline-block">{{typeData.readingTime}}</p>
            <i class="m-l-1 va-m icon-clock inline-block"></i>
            }
        </div>
    </div>

    <!-- Read more -->
    <href [link]="model?.data?.url">
        <button type="button"
                class="button-inline m-t m-b m-b-7-s">
            <span class="inline-block p-b-1">{{'Read article' | translate}}</span> </button>
    </href>

</href>
